import { render } from "./AttachRemoveOpportunity.vue?vue&type=template&id=5f3addfa"
import script from "./AttachRemoveOpportunity.vue?vue&type=script&lang=js"
export * from "./AttachRemoveOpportunity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__